const getAddressDomain = () => {
    
    const ret = window.location.href ? window.location.href.split("http://"): "";
    const ret2 = ret[1] ? ret[1].split("/")[0]: "";

    return ret2;
}
export const isLocalHost = getAddressDomain() === "localhost:3006";